import { render, staticRenderFns } from "./GovernmentId.vue?vue&type=template&id=0bf2893e&"
import script from "./GovernmentId.vue?vue&type=script&lang=js&"
export * from "./GovernmentId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports